import { render } from "./IssuePane.vue?vue&type=template&id=0823b5a2"
import script from "./IssuePane.vue?vue&type=script&lang=js"
export * from "./IssuePane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__